document.addEventListener('DOMContentLoaded', () => {
    setTimeout(() => {
        const el = document.getElementById('animated-headline')
        const text = el.textContent || ''
        el.textContent = ''

        const delayStep = 0.04
        let n = 0

        Array.from(text).forEach(ch => {
            if (ch === ' ') {
                el.appendChild(document.createTextNode(' '))
            } else {
                const span = document.createElement('span')
                span.className = 'letter'
                span.textContent = ch
                span.style.setProperty('--d', `${n * delayStep}s`)
                el.appendChild(span)
                n++
            }
        })
    }, 1000)
})
//# sourceMappingURL=animated-headline.js.map
